module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_04.e7236960.svg";